import { render, staticRenderFns } from "./coupons.vue?vue&type=template&id=019e4722&scoped=true&"
import script from "./coupons.vue?vue&type=script&lang=js&"
export * from "./coupons.vue?vue&type=script&lang=js&"
import style0 from "./coupons.vue?vue&type=style&index=0&id=019e4722&prod&lang=scss&"
import style1 from "./coupons.vue?vue&type=style&index=1&id=019e4722&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019e4722",
  null
  
)

export default component.exports